module.exports = __webpack_public_path__ + "images/bannerPT-49f8d05f21f491421d9e03c5f3d81b2e.jpg";